import React, { useState } from 'react';
import Popover from 'screens/shared/popover';
import Icon from 'screens/shared/icon';
import { ClickAwayListener } from '@mui/material';

export default ({
  content = '',
  iconName = 'info-circle',
  iconStyle = {},
  outerStyle = {},
  innerStyle = {},
  iconContainerStyle = {},
  showOnHover = true,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const hoverProps = {};

  if (showOnHover) {
    hoverProps.onMouseEnter = (e) => {
      if (!anchorEl) {
        setAnchorEl(e.currentTarget);
      }
    };

    hoverProps.onMouseLeave = () => {
      if (anchorEl) {
        setAnchorEl(null);
      }
    };
  }

  return (
    <>
      <Popover
        render={content}
        anchorEl={anchorEl}
        outerStyle={outerStyle}
        style={anchorEl ? innerStyle : { display: 'none' }}
      />
      <ClickAwayListener onClickAway={() => setAnchorEl(null)}>
        <span style={{ ...iconContainerStyle, zIndex: 1000 }} {...hoverProps}>
          <Icon
            name={iconName}
            style={iconStyle}
            onClick={(e) => setAnchorEl(e.target)}
          />
        </span>
      </ClickAwayListener>
    </>
  );
};
